import { bus } from '../core/event-bus.js';
import { store } from '../core/state-store.js';

/**
 * Syncs player state to data-* attributes on #vast-player so automation tools
 * can read state without JS evaluation (e.g., Playwright locator attributes).
 */
export function initDataBridge() {
  const el = document.getElementById('vast-player');
  if (!el) return;

  const sync = () => {
    const s = store.state;
    el.setAttribute('data-player-state', s.playerState);
    el.setAttribute('data-ad-on-stage', String(s.adOnStage));
    el.setAttribute('data-ad-type', s.adType || 'none');
    el.setAttribute('data-ad-duration', String(s.adDuration));
    el.setAttribute('data-ad-current-time', String(s.adCurrentTime));
    el.setAttribute('data-ad-paused', String(s.adPaused));
    el.setAttribute('data-muted', String(s.muted));
    el.setAttribute('data-volume', String(s.volume));
    el.setAttribute('data-audio-signal-detected', String(s.audioSignalDetected));
    el.setAttribute('data-audio-signal-level', String(s.audioSignalLevel));
    el.setAttribute('data-validation-status', s.validationStatus);
    el.setAttribute('data-session-status', s.sessionStatus);
    el.setAttribute('data-session-source-type', s.sessionSourceType || 'none');
    el.setAttribute('data-diagnostics-count', String(s.diagnosticsCount ?? 0));
    el.setAttribute('data-is-skippable', String(s.isSkippableAd));
    el.setAttribute('data-ad-linear', String(s.adLinear));
  };

  bus.on('state:changed', sync);
  bus.on('player:tick', sync);

  sync();
}
